import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import FileIcon from '../../../commonComponents/icons/FileIcon';
import { resolveDocumentUrl } from '../../../services/utilityFunctions';

function LessonDocuments(props) {
  const { t, documents } = props;
  if (!documents || documents.length === 0) return null;
  return (
    <div className="m-portlet m-portlet--rounded lesson-documents-portlet">
      <div className="m-portlet__body">
        <h4 className="lesson-documents-title">
          {t('academyDetails_documents')}
        </h4>
        <div className="lesson-documents-grid">
          {documents.map(doc => (
            <a
              key={doc._id || doc.url}
              /* BRAVON-6332 — a privatized document's stored url is the
                 authenticated api_media route, and an `<a target="_blank">`
                 cannot send a Bearer token. `resolveDocumentUrl` re-bases it
                 onto this portal's session-gated `/file/...` route; legacy
                 public urls come back unchanged. */
              href={resolveDocumentUrl(doc.url)}
              download={doc.originalName || doc.name || true}
              target="_blank"
              rel="noopener noreferrer"
              className="lesson-document-card"
              title={doc.originalName || doc.name || doc.url}
            >
              <FileIcon ext={doc.ext || ''} />
              <div className="lesson-document-card__name">
                {doc.originalName || doc.name || doc.url}
              </div>
              <i
                className="la la-download lesson-document-card__icon"
                aria-hidden="true"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

LessonDocuments.propTypes = {
  t: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.object),
};

LessonDocuments.defaultProps = {
  documents: [],
};

export default translate(LessonDocuments);
